/** Shell stack ids for Training Portal and nested training screens (not Scenario Studio `/scenarios`). */

export const TRAINING_SCREEN = '__training__'
export const TRAINING_LMS_SCREEN = '__training_lms__'
export const TRAINING_SCENARIOS_SCREEN = '__training_scenarios__'
export const TRAINING_SCENARIO_DETAIL_SCREEN = '__training_scenario_detail__'
export const TRAINING_TOOLBOX_TIPS_SCREEN = '__training_toolbox_tips__'
export const TRAINING_TOOLBOX_TIP_DETAIL_SCREEN = '__training_toolbox_tip_detail__'

export const TRAINING_SHELL_SCREEN_IDS = [
  TRAINING_SCREEN,
  TRAINING_LMS_SCREEN,
  TRAINING_SCENARIOS_SCREEN,
  TRAINING_SCENARIO_DETAIL_SCREEN,
  TRAINING_TOOLBOX_TIPS_SCREEN,
  TRAINING_TOOLBOX_TIP_DETAIL_SCREEN,
] as const

export type TrainingShellScreenId = (typeof TRAINING_SHELL_SCREEN_IDS)[number]

export function isTrainingShellScreen(id: string): boolean {
  return (TRAINING_SHELL_SCREEN_IDS as readonly string[]).includes(id)
}

export function trainingShellTitle(screenId: string): string | null {
  switch (screenId) {
    case TRAINING_SCREEN:
      return 'Training Portal'
    case TRAINING_LMS_SCREEN:
      return 'Pipeline Playbook'
    case TRAINING_SCENARIOS_SCREEN:
      return 'Scenarios'
    case TRAINING_SCENARIO_DETAIL_SCREEN:
      return 'Scenario'
    case TRAINING_TOOLBOX_TIPS_SCREEN:
      return 'Toolbox Tips'
    case TRAINING_TOOLBOX_TIP_DETAIL_SCREEN:
      return 'Toolbox Tip'
    default:
      return null
  }
}

/** Nested training screen → parent shell id (Training Portal, or the matching list). */
export function trainingBackTarget(screenId: string): string | null {
  switch (screenId) {
    case TRAINING_LMS_SCREEN:
    case TRAINING_SCENARIOS_SCREEN:
    case TRAINING_TOOLBOX_TIPS_SCREEN:
      return TRAINING_SCREEN
    case TRAINING_SCENARIO_DETAIL_SCREEN:
      return TRAINING_SCENARIOS_SCREEN
    case TRAINING_TOOLBOX_TIP_DETAIL_SCREEN:
      return TRAINING_TOOLBOX_TIPS_SCREEN
    default:
      return null
  }
}

export const TRAINING_LIST_PATHS = {
  [TRAINING_SCENARIOS_SCREEN]: '/training/scenarios',
  [TRAINING_TOOLBOX_TIPS_SCREEN]: '/training/toolbox-tips',
} as const

export const TRAINING_DETAIL_SCREEN_BY_LIST: Record<string, string> = {
  [TRAINING_SCENARIOS_SCREEN]: TRAINING_SCENARIO_DETAIL_SCREEN,
  [TRAINING_TOOLBOX_TIPS_SCREEN]: TRAINING_TOOLBOX_TIP_DETAIL_SCREEN,
}

export const TRAINING_LIST_SCREEN_BY_DETAIL: Record<string, string> = {
  [TRAINING_SCENARIO_DETAIL_SCREEN]: TRAINING_SCENARIOS_SCREEN,
  [TRAINING_TOOLBOX_TIP_DETAIL_SCREEN]: TRAINING_TOOLBOX_TIPS_SCREEN,
}
